import { useQuery } from '@tanstack/react-query';

import { DocumentStatusResource, Nullable } from '../../../../../types';
import { handleError } from '../../../../../utils/admin';
import { useRequestConstructor } from '../../../../hooks/useRequestConstructor';
import { unwrapNonPaginatedResponseDataAs } from '../../../../logic/unwrapNonPaginatedResponseDataAs';
import { APPLICATION_BASE_PATH } from '../../constants/applicationBasePath';
import { postApplicationDocumentStates } from '../../requests/postApplicationStates';

export const useApplicationDocumentStates = (
  uuid: string,
  definitionName: string,
  workflows: string[],
  status: Nullable<DocumentStatusResource> = null,
) => {
  const { constructPost } = useRequestConstructor();

  const { data, refetch, ...rest } = useQuery<
    Awaited<ReturnType<typeof postApplicationDocumentStates>>
  >({
    queryKey: [APPLICATION_BASE_PATH, uuid, 'states', workflows, status],
    queryFn: () =>
      postApplicationDocumentStates(constructPost, uuid, definitionName, {
        workflows,
      }),
    enabled: Boolean(uuid) && workflows.length > 0,
    onError: () => handleError('Could not find administrative workflows.'),
  });

  return {
    ...unwrapNonPaginatedResponseDataAs(data, refetch, 'documentStates'),
    ...rest,
  };
};
